module.exports = __webpack_public_path__ + "static/media/so-negative-margin.a1220a05.svg";